<template>
  <div
    v-if="hasAlipay && item.type === 1"
    :class="['tip-info', `st-${item.youKuStatus}`]"
  >
    {{ getStatusName(item.youKuStatus) }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['hasAlipay']),
  },

  methods: {
    getStatusName(v) {
      let str = '';
      switch (v) {
        case CONST.YOU_KU_STATUS.success:
          str = '优酷审核成功';
          break;
        case CONST.YOU_KU_STATUS.doing:
          str = '优酷审核中...';
          break;
        case CONST.YOU_KU_STATUS.fail:
          str = '优酷审核失败';
          break;
        default:
          break;
      }
      return str;
    },
  },
};
</script>

<style scoped lang="scss">
.tip-info {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  line-height: 40px;
  height: 40px;
  z-index: 1;
  color: #333;
  font-size: 14px;
  text-align: center;
  &.st-0 {
    background-color: rgb(124 204 124 / 80%);
  }
  &.st-1 {
    background-color: rgb(245 154 35 / 80%);
  }
  &.st-2 {
    background-color: rgb(255 0 0 / 70%);
  }
}
</style>
